module.exports = __webpack_public_path__ + "static/media/TSV-prosessi-materiaalitori-kuva-Tiina-Paju-web-sv-FI.9d8bc8ab.png";